module.exports = "pegasus/assets/theme6/small/6.jpg";